import { YouTube } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { MenuContext } from "../../contexts/menu-context";
import logo from "../../assets/home/greenisland-logo-256.png";
import "./header.scss";

const navItems = [
  {
    name: "Napelem",
    path: "#napelemes_rendszerek",
  },
  {
    name: "Energiatároló",
    path: "#energiatarolo",
  },
  {
    name: "Szolgáltatásaink",
    path: "#szolgaltatasaink",
  },
  {
    name: "Távfelügyelet",
    path: "#tavfelugyelet",
  },
  {
    name: "Blogok",
    path: "#blogok",
  },
  {
    name: "Kapcsolat",
    path: "#kapcsolat",
  },
];

const Header = () => {
  const { isDark } = useContext(MenuContext);
  const headerRef = useRef();
  const isTablet = useMediaQuery("(max-width: 1215px)");

  const scrollTopHandler = () => {
    if (window.location.pathname === "/") {
      window.scrollTo({ left: 0, top: 0 });
    } else {
      window.location.href = "/";
    }
  };

  useEffect(() => {
    const scrollHandler = () => {
      if (location.pathname !== "/f9a3c2dd20d43eda5d3e522ba2b79dfc") {
        if (
          document.body.scrollTop > 100 ||
          document.documentElement.scrollTop > 100
        ) {
          headerRef.current.classList.add("scroll");
        } else {
          headerRef.current.classList.remove("scroll");
        }
      }
    };

    window.addEventListener("scroll", scrollHandler);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  });

  const location = useLocation();

  return location.pathname === "/f9a3c2dd20d43eda5d3e522ba2b79dfc" ? (
    <></>
  ) : (
    <div
      ref={headerRef}
      className="header"
      style={isDark ? { color: "#fff" } : {}}>
      {/* <div className="banner">
        <a href="/" target="_blank">
          Otthon felújítási programunkért kattintson ide &rarr;
        </a>
      </div> */}
      <div className="header__content">
        <div className="header__content__logo">
          <span onClick={scrollTopHandler}>
            <img
              src={logo}
              alt="Green Island Invest – A jövő energiája"
              width="64"
              height="64"
            />
          </span>
        </div>

        {!isTablet && (
          <>
            <div className="header__content__menu">
              <Menu />
            </div>

            <div className="header__content__submenu">
              <Submenu />
            </div>
          </>
        )}
        {isTablet && <MobileNav />}
      </div>
    </div>
  );
};

const MobileNav = () => {
  const { isMenuShown, setIsMenuShown } = useContext(MenuContext);

  return (
    <div className={`header__content__mobnav ${isMenuShown ? "active" : ""}`}>
      {!isMenuShown && (
        <span className="menu" onClick={setIsMenuShown}>
          Menü
        </span>
      )}
      {isMenuShown && (
        <>
          <CloseIcon
            style={{ cursor: "pointer" }}
            fontSize="medium"
            onClick={setIsMenuShown}
          />

          <motion.div
            className="header__content__mobnav__nav"
            initial={{
              x: "100%",
            }}
            animate={{ x: 0 }}
            transition={{ duration: 0.5 }}>
            <Menu />
            <Submenu />
          </motion.div>
        </>
      )}
    </div>
  );
};

const LEGAL_PAGES = ["/aszf", "/adatkezelesi-tajekoztato", "/impresszum"];

const Menu = () => {
  const location = useLocation();
  const isLegalPage = LEGAL_PAGES.includes(location.pathname);
  let lakossagiGomb;
  if (isLegalPage) {
    lakossagiGomb = <></>;
  } else {
    lakossagiGomb = (
      <a
        href={
          location.pathname === "/" || location.pathname === "/lakossagi"
            ? "/vallalati"
            : "/lakossagi"
        }>
        {location.pathname === "/" || location.pathname === "/lakossagi"
          ? "Vállalati"
          : "Lakossági"}
      </a>
    );
  }
  return !isLegalPage &&
    !location.pathname.includes("/blog") &&
    !location.pathname.includes("/kitoltes") &&
    !location.pathname.includes("/kisokos") &&
    !location.pathname.includes("/otthonfelujitas") &&
    !location.pathname.includes("/nyugdijas") &&
    !location.pathname.includes("/palyazat") ? (
    <ul>
      {navItems.map((item, index) => (
        <li key={index}>
          <a href={item.path}>{item.name}</a>
        </li>
      ))}
      <li>{lakossagiGomb}</li>
    </ul>
  ) : (
    <ul>
      <li key="fooldal">
        <Link to="/#top">Vissza a főoldalra</Link>
      </li>
    </ul>
  );
};

const Submenu = () => {
  return (
    <ul>
      <li>
        <a
          href="https://www.facebook.com/greenislandinvestzrt"
          target="_blank"
          rel="noreferrer">
          <FacebookRoundedIcon />
        </a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/greenislandinvest"
          target="_blank"
          rel="noreferrer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root">
            <path
              fill="currentColor"
              d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
            />
          </svg>
        </a>
      </li>
      <li>
        <a
          href="https://www.tiktok.com/@greenislandinvest"
          target="_blank"
          rel="noreferrer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root">
            <path
              fill="currentColor"
              d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48"
            />
          </svg>
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/company/green-island-invest-hungary/"
          target="_blank"
          rel="noreferrer">
          <LinkedInIcon />
        </a>
      </li>
      <li>
        <a
          href="https://www.youtube.com/@GreenIslandInvestZrt."
          target="_blank"
          rel="noreferrer">
          <YouTube />
        </a>
      </li>
    </ul>
  );
};

export default Header;
